import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, IconButton } from '@mui/material';
import { useRollingWeeksLabel } from '../../../hooks/Forecast/useRollingWeeksLabel';

export default function InfoIcon({ data }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const rollingWeeksLabel = useRollingWeeksLabel();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'info-popover' : undefined;

  return (
    <>
      <IconButton onClick={handleClick} size="small">
        <InfoOutlinedIcon fontSize="inherit" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography sx={{ fontWeight: 700, mb: 1 }}>
            {data.name}
          </Typography>
          <Typography sx={{ mb: 1 }}>
            {rollingWeeksLabel}: {data.rolling_weeks ?? '-'}
          </Typography>
          <Typography sx={{ mb: 1 }}>Lastest Routes: {data.latest_routes ?? '-'}</Typography>
          <Typography sx={{ mb: 1 }}>Min Tour Cost: {data.min_tour_cost ?? '-'}</Typography>
          <Typography sx={{ mb: 1 }}>Max Tour Cost: {data.max_tour_cost ?? '-'}</Typography>
          <Typography sx={{ mb: 1 }}>Min Shipment Count: {data.min_shipment_count ?? '-'}</Typography>
          <Typography sx={{ mb: 1 }}>Max Shipment Count: {data.max_shipment_count ?? '-'}</Typography>
          <Typography sx={{ mb: 1 }}>Min OCAC: {data.min_ocac ?? '-'}</Typography>
          <Typography>Max OCAC: {data.max_ocac ?? '-'}</Typography>
        </Box>
      </Popover>
    </>
  );
}
